<template>
    <form
        class="form"
        @submit.prevent="handleSubmit">
        <transition name="fade">
            <div
                class="question"
                v-if="modifyFocus"
                key="question">
                What is your main focus for today?
                <input
                    class="input input-focus"
                    type="text"
                    v-model="focusInput"
                    ref="focusInput">
            </div>
            <div
                class="focus"
                v-else
                key="focus"
                @click="changeFocus">
                {{ focus }}
            </div>
        </transition>
    </form>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: "FocusForm",
    data: () => ({
        focusInput: "",
        modifyFocus: true
    }),
    computed: mapState(["focus"]),
    methods: {
        handleSubmit() {
            this.$store.commit("setFocus", this.focusInput);
            // cache the focus in localStorage
            localStorage.setItem("focus", this.focusInput);
            this.modifyFocus = false;
        },
        changeFocus() {
            // then user clicks the focus, go to modify mode
            this.modifyFocus = true;
        }
    },
    created() {
        if(this.focus) {
            // if the focus exists, go to display mode, and make the local state focusInput that value for future modifying
            this.modifyFocus = false;
            this.focusInput = this.focus;
        }
    }
}
</script>
  
<style scoped>
.form { width: 100%; }

.question {
    width: inherit;
    padding-bottom: 1rem;
    font-size: 2rem;
    font-weight: 300;
}

.input-focus {
    margin: 1rem auto;
    font-size: 2rem;
    font-weight: 500;
}

.focus {
    font-size: 3rem;
    cursor: pointer;
}
</style>